import React from 'react';
import { FaStarOfLife } from "react-icons/fa";
import './exp.css';

const Experience = () => {
  return (
    <div>
    <div id="experience">
    <div className='myexheads'>
    <h3 style={{marginBottom:5}} className='fnt351'>Behind My Works &</h3>
    <h2 style={{marginBottom:0}} className='fnt401'>My Experience</h2>
    <img src="/ssr.jpg" className='profiles' alt="professional web design and development chennai trichy tamilnadu" title="frontend developer uiux designer chennai trichy tamilnadu"/>
    <h2 style={{marginBottom:0}}> Hire Me </h2>
    <h3>Hi, I'm SivasundaraRaj - Codingwithssr 👋</h3>
  <p  style={{ fontSize: '12px' }}> Hi, I'm Sivasundararaj, founder of CodingWithSSR. Welcome to your trusted web design company in Chennai. As a Web Developer, Frontend Developer and UI/UX Designer with 10+ years of experience and 350+ successful projects, I turn your ideas into clean, responsive and conversion-focused websites.
           Whether you need a business website, a landing page, a custom web application or an online store, I handle web design in Chennai from wireframe to launch. I work with HTML, CSS, JavaScript, Bootstrap, AngularJS and React, and design in Figma, Adobe Photoshop and Adobe XD.
          <h2 style={{display:"block"}}>Web Design and Development Services in Chennai:</h2>
<ul>
<li><h3>Website Design in Chennai</h3></li>
<li><h3>Frontend Development</h3></li>
<li><h3>UI/UX Design Services</h3></li>            
<li><h3>Custom Web Applications</h3></li>
<li><h3>Responsive Website Design</h3></li>       
  <li><h3>E-commerce Solutions</h3></li>   
            </ul>
                    <img width="20" height="20" src="html5.png"  alt="website design in chennai" title="frontend developer uiux designer chennai trichy tamilnadu"  className='skillimg'/>
                    <img width="20" height="20" src="css3.png"  alt="website design in chennai" title="frontend developer uiux designer chennai trichy tamilnadu" className='skillimg'/>
                    <img width="20" height="20" src="javascript.png" alt="website design in chennai" title="frontend developer uiux designer chennai trichy tamilnadu" className='skillimg'/>
                <img width="20" height="20" src="bootstrap.png" className='skillimg' alt="website design in chennai" title="frontend developer uiux designer chennai trichy tamilnadu"/>
                <img width="20" height="20" src="react.png" alt="professional web design and development chennai trichy tamilnadu" title="frontend developer uiux designer chennai trichy tamilnadu" className='skillimg'/>           
                <img width="20" height="20" src="angularjs.png" className='skillimg' alt="professional web design and development chennai trichy tamilnadu" title="frontend developer uiux designer chennai trichy tamilnadu"/>               
                <img width="20" height="20" src="wordpress.png" className='skillimg' alt="professional web design and development chennai trichy tamilnadu" title="frontend developer uiux designer chennai trichy tamilnadu"/>
                <img width="20" height="20" src="shopify.png"  className='skillimg' alt="professional web design and development chennai trichy tamilnadu" title="frontend developer uiux designer chennai trichy tamilnadu"/>

                <img width="20" height="20" src="figma.png" alt="professional web design and development chennai trichy tamilnadu" title="frontend developer uiux designer chennai trichy tamilnadu"  className='skillimg' />
                <img width="20" height="20" src="adobe-photoshop.png" className='skillimg' alt="professional web design and development chennai trichy tamilnadu" title="frontend developer uiux designer chennai trichy tamilnadu"/>
                <img width="20" height="20" src="coreldraw.png" className='skillimg' alt="professional web design and development chennai trichy tamilnadu" title="frontend developer uiux designer chennai trichy tamilnadu"/>
        </p>
        
       </div> 
   <div className="containerss ">          
    
    <div className="myexp1">  
     <div className='desc'>
            <div className="descsub">               
                <h4 style={{margin:0}}>Projects</h4>                
                 <ul style={{ fontSize: '14px' }}>Why Choose CodingWithSSR for Web Design in Chennai?
 <li> 350+ projects completed across industries</li>
<li>10+ years of experience in web design and development, Continuous growth as a Frontend Development & UI/UX Design</li>
<li>200+ happy clients across Chennai and Tamil Nadu</li>
            <li>✅ 200+ happy clients across Chennai and Tamil Nadu</li>
<li>✅ MCA graduate with a strong technical foundation</li>
<li>✅ Multiple Technologies - Expert in HTML, CSS, JavaScript, Bootstrap, Tailwindcss, Angular.js, React, Figma,Adobe Photoshop, Adob XD,</li>
            <li>✅ Responsive design specialist with a mobile-first approach</li>
<li>✅ Performance Expert - Optimized websites with 60% faster load times</li>

            </ul>      
            </div> 
            <div className="descsub">
            <h4 style={{margin:0}}>Specialist</h4>              
                     <ul style={{ fontSize: '12px' }}>
 <li> User-Centric Design: As a UI/UX Designer in Chennai Trichy, I prioritize user experience in every project</li>
 <li> Clean Code Philosophy: Professional web development with maintainable, scalable code</li>
 <li> Continuous Learning: Staying updated with latest frontend development trends</li>

            </ul>      
            </div> 
            <div className="descsub">
                  <h4 style={{margin:0}}>Clients</h4>
                   <ul style={{ fontSize: '12px' }}>
 <li> Local Expertise: Understanding Chennai and Trichy business landscapes</li>
 <li> Client Collaboration: Your vision combined with Codingwithssr's expertise</li>
 <li> Quality Assurance: Professional web design and development that exceeds expectations</li>
            </ul> 
            </div> 
      </div>
     
   </div>
    </div>  
  
    </div>
  <div className='role'>
    <div className='roleinfo'>
    <span>Dashboard</span><span><FaStarOfLife/></span>
    <span>Admin Design</span><span><FaStarOfLife/></span>
    <span>Landing Website</span><span><FaStarOfLife/></span>
    <span>Dynamic Website</span><span><FaStarOfLife/></span>
    <span>Mobile App Design</span><span><FaStarOfLife/></span>
    </div>
    </div>
  </div>
  );
};

export default Experience;






































